import React, { useEffect, useState, useCallback } from 'react';

const Doorbell: React.FC = () => {
  const [lastCallTime, setLastCallTime] = useState<number | null>(null);
  const [isCooldown, setIsCooldown] = useState(false);
  const [remainingTime, setRemainingTime] = useState(0);

  const COOLDOWN_PERIOD = 2 * 60 * 1000; // 2 minutes in milliseconds

  const call_endpoint = useCallback(async () => {
    const now = Date.now();
    
    // Check if we're in cooldown period
    if (lastCallTime && (now - lastCallTime) < COOLDOWN_PERIOD) {
      console.log('Doorbell is in cooldown');
      return;
    }

    try {
      console.log('Calling endpoint...');
      // Replace with your actual endpoint URL
      const response = await fetch('https://ntfy.sh/tvcologan-hbtm-30-leon1', {
        method: 'POST',
        body: "¡Alguien está en la puerta!"
      });
      
      if (response.ok) {
        console.log('Endpoint called successfully');
        setLastCallTime(now);
        setIsCooldown(true);
        
        // Start cooldown countdown
        const countdownInterval = setInterval(() => {
          const elapsed = Date.now() - now;
          const remaining = Math.max(0, COOLDOWN_PERIOD - elapsed);
          setRemainingTime(remaining);
          
          if (remaining === 0) {
            setIsCooldown(false);
            clearInterval(countdownInterval);
          }
        }, 1000);
        
      } else {
        console.error('Failed to call endpoint');
      }
    } catch (error) {
      console.error('Error calling endpoint:', error);
    }
  }, [lastCallTime, COOLDOWN_PERIOD]);

  useEffect(() => {
    call_endpoint();
  }, [call_endpoint]);

  const formatTime = (milliseconds: number) => {
    const minutes = Math.floor(milliseconds / 60000);
    const seconds = Math.floor((milliseconds % 60000) / 1000);
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
      <div className="text-center">
        <div className="inline-block">
          <div 
            className={`cursor-pointer ${isCooldown ? 'opacity-50 cursor-not-allowed' : 'hover:scale-105 transition-transform'}`} 
            onClick={!isCooldown ? call_endpoint : undefined}
          >
            <svg 
              width="400px" 
              height="400px" 
              viewBox="0 0 64 64" 
              xmlns="http://www.w3.org/2000/svg" 
              stroke-width="3" 
              stroke={isCooldown ? "#9CA3AF" : "#000000"} 
              fill="none"
              className={isCooldown ? 'animate-pulse' : ''}
            >
              <path d="M13.4,51V46.21s4.83-.24,4.83-4.83V26.1s-.05-12.67,13.63-12.67c12.06,0,15,7,15,12.21V42.23s-.36,4,4.8,4V51Z"/>
              <path d="M36.24,13.79V12.47a3.74,3.74,0,0,0-7.48,0v1.2"/>
              <path d="M36.33,51a4.57,4.57,0,0,1-9.13,0"/>
              <path d="M50.5,33.49A4.67,4.67,0,0,1,52,41.08"/>
              <path d="M53.3,30a8,8,0,0,1,2.59,13"/>
              <path d="M14,33.74a4.66,4.66,0,0,0-1.51,7.59"/>
              <path d="M11.17,30.26a8,8,0,0,0-2.59,13"/>
            </svg>
          </div>
        </div>
        <p className="mt-6 text-lg md:text-xl text-gray-700 font-medium">
          🚪 Timbre
        </p>
        <p className="mt-2 text-sm md:text-base text-gray-500">
          {isCooldown 
            ? `⏰ Espera ${formatTime(remainingTime)} para volver a tocar` 
            : 'Toca la campana para llamar otra vez al timbre'
          }
        </p>
        {isCooldown && (
          <div className="mt-4 inline-block bg-yellow-100 text-yellow-800 px-4 py-2 rounded-lg text-sm font-medium">
            ⏳ Timbre en espera...
          </div>
        )}
      </div>
    </div>
  );
};

export default Doorbell;
